import React from "react"

// Shared date-range quick presets. Reusable across any filter bar that carries
// `from`/`to` ISO date strings (Traffic, Transactions, Subscriptions, …).
// `onSelect(from, to)` receives local YYYY-MM-DD bounds; callers decide whether
// to apply immediately or stage into a draft.

const iso = (d) => {
  const z = new Date(d.getTime() - d.getTimezoneOffset() * 60000)
  return z.toISOString().slice(0, 10)
}

// key → (today) => [from, to]. All bounds inclusive, local time.
export const PRESETS = {
  today: (t) => [t, t],
  yesterday: (t) => { const d = new Date(t); d.setDate(d.getDate() - 1); return [d, d] },
  this_week: (t) => { const s = new Date(t); s.setDate(s.getDate() - ((s.getDay() + 6) % 7)); return [s, t] }, // Mon start
  this_month: (t) => [new Date(t.getFullYear(), t.getMonth(), 1), t],
  last_30_days: (t) => { const s = new Date(t); s.setDate(s.getDate() - 29); return [s, t] },
  last_6_months: (t) => { const s = new Date(t); s.setMonth(s.getMonth() - 6); return [s, t] },
}

export const PRESET_KEYS = Object.keys(PRESETS)

export function rangeForPreset(key) {
  const fn = PRESETS[key]
  if (!fn) return null
  const [from, to] = fn(new Date())
  return { from: iso(from), to: iso(to) }
}

const chip =
  "rounded-full border border-gray-200 px-2.5 py-1 text-xs font-medium text-gray-600 hover:border-brand-500 hover:text-brand-600 dark:border-gray-700 dark:text-gray-400 dark:hover:border-brand-500 dark:hover:text-brand-400"

export default function DateRangePresets({ onSelect, labels, keys = PRESET_KEYS }) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {keys.map((k) => (
        <button
          key={k}
          type="button"
          onClick={() => {
            const r = rangeForPreset(k)
            if (r) onSelect(r.from, r.to)
          }}
          className={chip}
        >
          {labels?.[k] || k}
        </button>
      ))}
    </div>
  )
}
